import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs';

import * as moment from 'moment';

import { HelpConfig } from '@config/help-config';
import { Token } from '@models/outros/token.model';
import { TokenService } from './token.service';
import { UserLoginModel } from '@models/outros/user-login.model';
import { UserControllerService } from './user-controller.service';
import { mergeMap } from 'rxjs/operators';
import { RolePermissionService } from '../apis/identidade/role-permission.service';
import { PermissionStorageModel, UserPermissionsService } from './user-permissions.service';
import { RoleService } from '../apis/identidade/role.service';
import { Helper } from '@core/utils/helper';

@Injectable()
export class AuthService implements OnDestroy {

  token: Token = null;
  private _subscription: Subscription;

  constructor(
    private _httpClient: HttpClient,
    private _helpConfig: HelpConfig,
    private _tokenService: TokenService,
    private _userControllerService: UserControllerService,
    private _rolePermission: RolePermissionService,
    private _roleService: RoleService,
    private _userPermissions: UserPermissionsService,
  ) {
    this._subscription = new Subscription();
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  authenticate(user: any, successCallBack, errorCallBack) {

    let userLogin: UserLoginModel = new UserLoginModel();
    let permissionStorage: PermissionStorageModel = new PermissionStorageModel();

    const payload = {
      'username': user.username,
      'password': user.password
    }

    this._subscription.add(
      this.login(payload).pipe(
        mergeMap(
          (resultLogin) => {
            userLogin = resultLogin;
            userLogin.roles = userLogin.roles.sort(function (a, b) {
              if (a.name > b.name) return 1;
              if (a.name < b.name) return -1;
              return 0;
            });
            permissionStorage.user = resultLogin.userName;
            this._tokenService.setToken(resultLogin);
            this._userControllerService.setUser(resultLogin);
            return this._roleService.getAll();
          }
        ),
        mergeMap(
          (result) => {
            let role = result.find(x => x.name == userLogin.type);
            this._userPermissions.setRolesSubject(result);
            this._userPermissions.setRoleStorage(result);
            return this._rolePermission.getAll({ roleId: role.id });
          }
        ),
      ).subscribe(
        {
          next: (result) => {
            permissionStorage.permissions = result;
            this._userPermissions.setPermissionsSubject(result);
            this._userPermissions.setPermissionsStorage(permissionStorage);
            return successCallBack(true)
          },
          error: (err) => errorCallBack(err)
        },
      )
    )
  }

  login(payload: any): Observable<any> {
    const END_POINT: string = 'autenticacao';
    return this._httpClient.post(`${this._helpConfig.MANAGEMENT_API}${END_POINT}`, payload);
  }
}
